import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/useAuth";
import "../styles/ContactPage.css";

const API =
  "https://squid-app-6s2hc.ondigitalocean.app";

export default function ContactPage() {

  const navigate = useNavigate();
  const { user } = useAuth();

  const [showContactModal, setShowContactModal] = useState(false);
  const [messageText, setMessageText] = useState("");
  const [sending, setSending] = useState(false);

  const sendMessage = async () => {

    if (!messageText.trim()) return;

    setSending(true);

    try {

      const res = await fetch(
        `${API}/send-message`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            recipientUsername: "shaq",
            message: messageText,
            email: user.email
          })
        }
      );

      const data = await res.json();

      if (res.ok && data.success) {
        setShowContactModal(false);
        setMessageText("");
      }

    } finally {
      setSending(false);
    }

  };

  return (
    <main className="contact-page">

      <button
        className="contact-back"
        onClick={() => navigate(-1)}
      >
        ← back
      </button>

      <section className="contact-panel">

        <h1 className="contact-heading">
          need a hand?
        </h1>

        <p className="contact-copy">
          if something isn't working, you have a suggestion,
          or you're unsure what to do next, feel free to reach out.
        </p>

        <button
          className="contact-button"
          onClick={() => setShowContactModal(true)}
        >
          message @shaq
        </button>

        <div className="contact-divider" />

        <div className="contact-email-label">
          or email
        </div>

        <a
          className="contact-email"
          href="mailto:shaq@thecollectorsplatform.com"
        >
          shaq@thecollectorsplatform.com
        </a>

        <div className="contact-footer">
          — Sarah Haq, founder
        </div>

      </section>

      {showContactModal && (

        <div
          className="vc-modal-overlay"
          onClick={() => setShowContactModal(false)}
        >

          <div
            className="vc-modal"
            onClick={(e) => e.stopPropagation()}
          >

            <button
              className="vc-modal-close"
              onClick={() => setShowContactModal(false)}
            >
              ×
            </button>

            <p className="vc-modal-title">
              message @shaq
            </p>

            <div className="vc-contact-form">

              <textarea
                className="vc-share-input"
                rows={8}
                placeholder="insert your message here"
                value={messageText}
                onChange={(e) =>
                  setMessageText(e.target.value)
                }
              />

              <button
                className="vc-share-copy"
                onClick={sendMessage}
                disabled={sending}
              >
                {sending ? "sending..." : "send"}
              </button>

            </div>

          </div>

        </div>

      )}

    </main>
  );

}